const WORKER_URL = import.meta.env.VITE_WORKER_URL ?? "http://localhost:8787";

// People (design_documents/people.md) through the worker's /people routes:
// an item's credits, a person with their works, and person search. Sources:
// movies → Wikidata, TV → TVmaze, books → Open Library (comics keep Metron).

async function request(path, { signal } = {}) {
	const resp = await fetch(`${WORKER_URL}${path}`, { signal });
	if (!resp.ok) {
		let message = `Request failed: ${resp.status}`;
		try {
			const body = await resp.json();
			if (body?.error) message = body.error;
		} catch {
			// non-JSON body, keep default message
		}
		const err = new Error(message);
		err.status = resp.status;
		throw err;
	}
	return resp.json();
}

// The people credited on an item → [{ source, person_id, name, roles, image }].
// `mediaType` is movie | tv | book; `externalId` the item's source id.
export function getCredits(mediaType, externalId, { signal } = {}) {
	return request(`/people/for/${mediaType}/${encodeURIComponent(externalId)}`, { signal });
}

// A person and their works in that source's category →
// { person: { source, person_id, name, image, summary, born },
//   works: [{ media_type, external_id, title, year, cover_url, roles }] }.
export function getPerson(source, personId, { media = null, signal } = {}) {
	const q = media ? `?media=${encodeURIComponent(media)}` : "";
	return request(`/people/${source}/${encodeURIComponent(personId)}${q}`, { signal });
}

// The route to a person's page. Wikidata people serve several categories, so
// their page carries which one (?media=game|anime); films are the default.
export function personRoute(source, personId, mediaType) {
	const base = `/people/${source}/${encodeURIComponent(personId)}`;
	if (source === "wikidata" && mediaType === "videogame") return `${base}?media=game`;
	if (source === "wikidata" && mediaType === "anime") return `${base}?media=anime`;
	return base;
}

// Search people at one source → [{ source, person_id, name, image, summary }].
export function searchPeople(source, query, { signal } = {}) {
	const params = new URLSearchParams({ source, q: query });
	return request(`/people/search?${params}`, { signal });
}
